import Phaser from 'phaser';
import { COLORS, OUTLINE, SHADOW_Y } from '../theme';

export interface OutlinedRectOpts {
  fill?: number;
  border?: number;
  outline?: number;
  radius?: number;
  shadow?: number;
  shadowColor?: number;
}

/**
 * Draw a chunky "Stage Pop" outlined rounded rect with a flat drop shadow.
 * Returned Container is centered on (x, y) and holds: shadow rect, fill rect, outline.
 */
export function drawOutlinedRect(
  scene: Phaser.Scene,
  x: number,
  y: number,
  w: number,
  h: number,
  opts: OutlinedRectOpts = {},
): Phaser.GameObjects.Container {
  const fill = opts.fill ?? COLORS.white;
  const border = opts.border ?? COLORS.ink;
  const outline = opts.outline ?? OUTLINE;
  const radius = opts.radius ?? 24;
  const shadow = opts.shadow ?? SHADOW_Y;
  const shadowColor = opts.shadowColor ?? border;

  const container = scene.add.container(x, y);

  if (shadow > 0) {
    const g = scene.add.graphics();
    g.fillStyle(shadowColor, 1);
    g.fillRoundedRect(-w / 2, -h / 2 + shadow, w, h, radius);
    container.add(g);
  }

  const body = scene.add.graphics();
  body.fillStyle(fill, 1);
  body.fillRoundedRect(-w / 2, -h / 2, w, h, radius);
  body.lineStyle(outline, border, 1);
  body.strokeRoundedRect(-w / 2, -h / 2, w, h, radius);
  container.add(body);

  return container;
}

/** Draw a filled circle with a thick outline (no shadow). */
export function drawOutlinedCircle(
  scene: Phaser.Scene,
  x: number,
  y: number,
  r: number,
  fill = COLORS.white,
  border = COLORS.ink,
  outline = OUTLINE,
): Phaser.GameObjects.Graphics {
  const g = scene.add.graphics({ x, y });
  g.fillStyle(fill, 1);
  g.fillCircle(0, 0, r);
  g.lineStyle(outline, border, 1);
  g.strokeCircle(0, 0, r);
  return g;
}
